import {
  AddRoad,
  EditCalendar,
  LocationOn,
  MyLocation,
  RadioButtonChecked,
} from "@mui/icons-material";
import { faArrowLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Autocomplete, TextField } from "@mui/material";
import {
  createReservation,
  getBalance,
  getStops,
  getFare,
  getReservationTemplates,
} from "../apiServices/apiServices";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomToastContainer from "../components/CustomToastContainer";
import ConfirmBookingModal from "../components/ConfirmBookingModal";
import DatePickerDialog from "../components/MyDayPicker";
import moment from "moment";
import { confirmToast } from "../components/ConfirmToast";
import { alertToast } from "../components/AlertToast";

export default function ReserveSeat() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(window.localStorage.getItem("user"));
  const userId = user.id;

  const subRoute = location.state?.subRoute || {};
  const reorderData = location.state.reorderData || {};

  const [completeRouteId, setCompleteRouteId] = useState();
  const [routeId, setRouteId] = useState();
  const [allTemplates, setAllTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [stopSelectionEnabled, setStopSelectionEnabled] = useState(false);

  var formattedDate;

  const [gender, setGender] = useState("m");

  const [balance, setBalance] = useState(0);
  const [fare, setFare] = useState(0);

  const [pickupStop, setPickupStop] = useState(null);
  const [dropoffStop, setDropoffStop] = useState(null);

  const [stops, setStops] = useState([]);

  const [openModal, setOpenModal] = useState(false);

  const [openDateModal, setOpenDateModal] = useState(false);
  const [reservationDate, setReservationDate] = useState(new Date());
  const [reserveBtnDisabled, setReserveBtnDisabled] = useState(false);
  const [reservingSeat, setReservingSeat] = useState(false);

  const handleClickOpen = () => {
    setOpenDateModal(true);
  };

  const handleClose = () => {
    setOpenDateModal(false);
  };

  const handleDateSelect = (date) => {
    setReservationDate(date);
    // console.log('Selected Date:', date);
  };

  const [reserve, setReserve] = useState({
    route_id: "",
    user_id: "",
    reservation_date: "",
    reservation_dates: [""],
    pickup_lat: "",
    pickup_long: "",
    dropoff_lat: "",
    dropoff_long: "",
    pickup_stop_id: "",
    dropoff_stop_id: "",
    gender: "",
    deduct_cutoff_fare: false,
  });

  const item = {
    ...reorderData,
    ...subRoute,
  };

  const handleCancel = () => {
    setOpenModal(false);
    setReserveBtnDisabled(false);
  };

  const handleConfirm = async (
    deductCutoffFare = reserve.deduct_cutoff_fare,
  ) => {
    if (reservingSeat) return; // Prevent multiple clicks
    setReservingSeat(true);
    try {
      const reservationData = {
        ...reserve,
        deduct_cutoff_fare: deductCutoffFare,
      };

      const response = await createReservation(reservationData);
      console.log("Response:", response);
      if (response && response.success) {
        const cutOffErrors = response.errors.filter(
          (error) => error.error_code === "5001",
        );
        if (cutOffErrors.length > 0) {
          let message = response.message;
          message +=
            "\n\n• Would you like to book your seat(s) now at the advance booking fare?";
          const confirmed = await confirmToast(message);
          if (confirmed) {
            setReserve((prev) => ({
              ...prev,
              deduct_cutoff_fare: true,
            }));
            await handleConfirm(true);
          } else {
            setReserveBtnDisabled(false);
            setReservingSeat(false);
          }
          return;
        }

        const confirmed = await alertToast(
          response.message || "Seat reserved successfully!",
        );

        if (confirmed) {
          // navigate("/reservations");
          navigate(-3);
        }
      } else {
        toast.error(response.message || "Failed to reserve seat");
      }
      setReserveBtnDisabled(false);
      setReservingSeat(false);
    } catch (error) {
      setOpenModal(false);
      setReserveBtnDisabled(false);
      setReservingSeat(false);
      console.error("Error:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  useEffect(() => {
    const updateStops = async () => {
      const selectedPickupStop = stops?.find(
        (stop) => stop.id === reorderData.pickupStopId,
      );
      const selectedDropoffStop = stops?.find(
        (stop) => stop.id === reorderData.dropoffStopId,
      );

      setPickupStop(selectedPickupStop || null);
      setDropoffStop(selectedDropoffStop || null);

      // console.log("Pickup stop from re-order: ", selectedPickupStop);
      // console.log("Dropoff stop from re-order: ", selectedDropoffStop);
    };
    if (reorderData != null) {
      updateStops();
    }
  }, [stops]);

  // useEffect(() => {
  //   setReserve((prev) => ({
  //     ...prev,
  //     route_id: item?.routeId || item?.id,
  //   }));
  // }, [item]);

  useEffect(() => {
    const routeId = item?.routeId || item?.id;
    setRouteId(routeId);
    setReserve((prev) => ({
      ...prev,
      route_id: routeId || "",
    }));
    const fetchStops = async () => {
      try {
        const response = await getStops(routeId?.toString());
        // console.log("Response:", response);
        if (response && response.success) {
          const filteredStops = response?.data.stops?.filter(
            (stop) =>
              !stop.name.includes("Pick") && !stop.name.includes("Drop"),
          );

          const finalStops = filteredStops?.filter(
            (stop) => stop.type === "Fairing" && stop.visibility === 1,
          );
          setStops(finalStops || []);
        } else {
          toast.error(response.message || "Failed to fetch stops");
        }
      } catch (error) {
        console.error("Error:", error);
        toast.error("An error occurred. Please try again.");
      }
    };

    fetchStops();
    fetchReservationTemplates(item.complete_route_id);
  }, []);

  const fetchReservationTemplates = async (completeRouteId) => {
    try {
      const response = await getReservationTemplates(completeRouteId);
      if (response && response.success) {
        const count = response.data.templates.length || 0;
        if (count > 0) {
          const template = response.data.templates[0];
          setSelectedTemplate(template);

          setReserve((prev) => ({
            ...prev,
            pickup_stop_id: template.pickup_stop_id,
            pickup_lat: template.pickup_lat,
            pickup_long: template.pickup_long,

            dropoff_stop_id: template.dropoff_stop_id,
            dropoff_lat: template.dropoff_lat,
            dropoff_long: template.dropoff_long,
          }));
          getFareMethod(
            template.route_id,
            template.pickup_stop_id,
            template.dropoff_stop_id,
          );
        }
        setStopSelectionEnabled(count == 0);
        setAllTemplates(response.data.templates);
      } else {
        toast.error(response.message || "Failed to fetch templates");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  const handleChange = (event) => {
    setGender(event.target.value);
  };

  useEffect(() => {
    formattedDate = moment(reservationDate).format("YYYY-MM-DD") || "";
    setReserve((prev) => ({
      ...prev,
      user_id: userId || "",
      reservation_date: formattedDate || "",
      reservation_dates: [formattedDate || ""],
      gender: gender || "",
    }));
  }, [reservationDate, gender]);

  useEffect(() => {
    // console.log("Pickup Stop",pickupStop)
    // console.log("DropOff Stop",dropoffStop)
    if (pickupStop && dropoffStop) {
      getFareMethod(reserve.route_id, pickupStop.id, dropoffStop.id);
    } else if (selectedTemplate) {
      getFareMethod(
        reserve.route_id,
        selectedTemplate.pickup_stop_id,
        selectedTemplate.dropoff_stop_id,
      );
    }
  }, [pickupStop, dropoffStop, selectedTemplate]);

  useEffect(() => {
    const updateReserve = async () => {
      setReserve((prev) => ({
        ...prev,
        pickup_stop_id: pickupStop?.id || "",
        pickup_lat: pickupStop?.latitude || "",
        pickup_long: pickupStop?.longitude || "",
      }));
      // console.log("Pickup Off : ", reserve.route_id + " " + reserve.pickup_stop_id + " " + reserve.dropoff_stop_id);
    };
    updateReserve();
  }, [pickupStop]);

  useEffect(() => {
    const updateReserve = async () => {
      setReserve((prev) => ({
        ...prev,
        dropoff_stop_id: dropoffStop?.id || "",
        dropoff_lat: dropoffStop?.latitude || "",
        dropoff_long: dropoffStop?.longitude || "",
      }));
      // console.log("Drop Off : ", reserve.route_id + " " + reserve.pickup_stop_id + " " + reserve.dropoff_stop_id);
    };

    updateReserve();
  }, [dropoffStop]);

  const getFareMethod = async (routeId, pickupStopId, dropoffStopId) => {
    try {
      const data = {
        routeId: routeId,
        pickupStopId: pickupStopId,
        dropoffStopId: dropoffStopId,
      };
      // console.log("Data : ", data);
      if (data.routeId && data.pickupStopId && data.dropoffStopId) {
        const response = await getFare(data);
        console.log("Fare Response:", response);

        if (response && response.success) {
          setFare(response.data.fare);
        } else {
          // console.log(response.message || 'Failed to get Fare');
          toast.error(response.message || "Failed to get Fare");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  const checkBalanceMethod = async () => {
    try {
      setReserveBtnDisabled(true);
      const response = await getBalance(userId);
      // console.log("Balance Response:", response);
      if (response && response.success) {
        setBalance(response?.data?.balance);
        if (response?.data?.balance >= fare) {
          setOpenModal(true);
        } else {
          toast.error(
            `Insufficient balance! Rs. ${response?.data?.balance} Please top-up your wallet.`,
          );
          setReserveBtnDisabled(false);
        }
      } else {
        console.error(response.message || "Failed to get balance");
        toast.error(response.message || "Failed to fetch balance");
        setReserveBtnDisabled(false);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred. Please try again.");
      setReserveBtnDisabled(false);
    }
  };

  const handleReserveSeat = async () => {
    // console.log("stops: ", stops)
    // console.log("reserve pickup: " + reserve.pickup_lat + "," + reserve.pickup_long)
    // console.log("reserve dropoff: " + reserve.dropoff_lat + "," + reserve.dropoff_long)
    // console.log(reserve.pickup_stop_id)
    // console.log(reserve.dropoff_stop_id)
    // console.log(reserve.gender)
    // console.log(reserve.reservation_date)
    // console.log("user: "+reserve.user_id)
    // console.log("route: "+reserve.route_id)
    // console.log("selectedTemplate: ", selectedTemplate);
    if (
      (stopSelectionEnabled && (!pickupStop || !dropoffStop)) ||
      (!stopSelectionEnabled && !selectedTemplate) ||
      !reservationDate ||
      !gender
    ) {
      toast.error("Please complete all fields before proceeding.");
      return;
    }
    if (
      reserve.pickup_stop_id === 0 ||
      reserve.pickup_lat === 0.0 ||
      reserve.pickup_long === 0.0
    ) {
      toast.error("Select appropriate pickup stop.");
      return false;
    }

    if (
      reserve.pickup_stop_id === 0 ||
      reserve.dropoff_lat === 0.0 ||
      reserve.dropoff_long === 0.0
    ) {
      toast.error("Select appropriate drop off stop.");
      return false;
    }
    console.log(reserve);
    await checkBalanceMethod();
  };

  const handleNavigation = (path) => {
    navigate(path);
  };
  return (
    <>
      <div className="w-full h-screen bg-gray-100">
        <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
          <button
            className="text-gray-600 items-center"
            onClick={() => handleNavigation(-1)}
          >
            <FontAwesomeIcon icon={faArrowLeft} size="lg" />
          </button>
          <div className="flex items-center justify-center flex-grow gap-2">
            <h1 className="text-gray-600 font-semibold text-lg">
              Reserve Seat
            </h1>
          </div>
        </nav>

        <div className="overflow-y-auto flex-grow p-4">
          <div className="mb-4">
            <h3 className="text-gray-800 font-semibold text-md lg:text-lg mb-2">
              Route Name:
            </h3>
            <div className="flex items-center bg-white p-4 rounded shadow-sm">
              <AddRoad className="text-[#BE1F18]" />
              <span className="ml-3 text-gray-800">
                {item.user_readable_name}
              </span>
            </div>
          </div>
          <div className="flex mb-4">
            <div className="flex-1 pr-2">
              <h3 className="text-gray-800 font-semibold text-md lg:text-lg mb-2">
                Select Gender:
              </h3>
              <div className="bg-white p-4 rounded shadow-sm flex items-center">
                <select
                  className="w-full h-10 px-4 rounded-2xl bg-gray-200"
                  value={gender}
                  onChange={handleChange}
                >
                  <option value="m">Male</option>
                  <option value="f">Female</option>
                </select>
              </div>
            </div>
            <div className="flex-1 pl-2">
              <h3 className="text-gray-800 font-semibold text-md lg:text-lg mb-2">
                Select Date:
              </h3>
              <div className="bg-white p-4 rounded shadow-sm flex items-center">
                <span className="w-full h-10 flex items-center justify-between px-4 bg-gray-200 rounded-2xl">
                  <p>
                    {reservationDate
                      ? moment(reservationDate).format("ddd, D")
                      : moment().format("ddd, D")}
                  </p>
                  <button onClick={handleClickOpen}>
                    <EditCalendar alt="Calendar" className="w-5 h-5" />
                  </button>
                </span>
                <DatePickerDialog
                  open={openDateModal}
                  onClose={handleClose}
                  onDateSelect={handleDateSelect}
                />
              </div>
            </div>
          </div>
          <div className="mb-4">
            <h3 className="text-gray-800 font-semibold text-md lg:text-lg mb-2">
              Select Pickup and Dropoff Location:
            </h3>
            {stopSelectionEnabled && (
              <div className="bg-white p-4 rounded shadow-sm flex items-center">
                <div className="flex flex-col items-center mr-3">
                  <RadioButtonChecked
                    alt="Start"
                    fontSize="small"
                    className=" text-gray-500"
                  />
                  <span className="text-gray-500 ">•</span>
                  <span className="text-gray-500 ">•</span>
                  <span className="text-gray-500 ">•</span>
                  <LocationOn
                    alt="End"
                    fontSize="small"
                    className="w-4 h-4 text-gray-500 mt-1"
                  />
                </div>
                <div className="flex flex-col flex-grow">
                  <div className="flex flex-row bg-gray-200 items-center rounded px-4 py-2 mb-2">
                    <Autocomplete
                      value={pickupStop}
                      onChange={(event, newValue) => setPickupStop(newValue)}
                      disabled={!stopSelectionEnabled}
                      disablePortal
                      options={stops}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Pickup Stop" />
                      )}
                      className="w-full"
                    />
                    <MyLocation alt="Calendar" className="w-5 h-5 ml-2" />
                  </div>
                  <div className="flex flex-row bg-gray-200 items-center rounded px-4 py-2">
                    <Autocomplete
                      value={dropoffStop}
                      onChange={(event, newValue) => setDropoffStop(newValue)}
                      disabled={!stopSelectionEnabled}
                      disablePortal
                      options={stops}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Dropoff Stop" />
                      )}
                      className="w-full"
                    />
                    <MyLocation alt="Calendar" className="w-5 h-5 ml-2" />
                  </div>
                </div>
              </div>
            )}
            {!stopSelectionEnabled && (
              <div className="bg-white p-4 rounded shadow-sm flex items-center">
                <select
                  className="w-full h-10 px-4 rounded-2xl bg-gray-200"
                  onChange={(template) => {
                    setSelectedTemplate(template);
                    setReserve((prev) => ({
                      ...prev,
                      pickup_stop_id: template.pickup_stop_id,
                      pickup_lat: template.pickup_lat,
                      pickup_long: template.pickup_long,

                      dropoff_stop_id: template.dropoff_stop_id,
                      dropoff_lat: template.dropoff_lat,
                      dropoff_long: template.dropoff_long,
                    }));
                  }}
                >
                  {allTemplates.map((t, index) => (
                    <option key={t.id || index} value={t.id || index}>
                      {`${t.pickup_stop_name} ➝ ${t.dropoff_stop_name}`}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>
          {((dropoffStop && pickupStop) || selectedTemplate) && (
            <div className="mb-4">
              <h3 className="text-gray-800 font-semibold text-md lg:text-lg mb-2">
                Calculated Fare:
              </h3>
              <div className="bg-[#BE1F18] rounded font-bold text-white text-center text-lg py-2">
                PKR {fare}
              </div>
            </div>
          )}
          <button
            disabled={reserveBtnDisabled}
            style={{
              backgroundColor: reserveBtnDisabled ? "lightgray" : "transparent",
              borderColor: reserveBtnDisabled ? "lightgray" : "#BE1F18",
              color: reserveBtnDisabled ? "gray" : "#BE1F18",
            }}
            onClick={handleReserveSeat}
            className="flex mt-4 text-[#BE1F18] border border-[#BE1F18] focus:ring-4 focus:outline-none focus:ring-red-300 font-medium text-center rounded-lg text-sm w-full px-5 py-2.5 items-center"
          >
            <span className="flex-1 mr-2">Proceed</span>
            <FontAwesomeIcon
              icon={faChevronRight}
              className="text-[#BE1F18]"
              alt="Proceed"
            />
          </button>
        </div>
      </div>
      <CustomToastContainer />
      {openModal && (
        <ConfirmBookingModal
          open={openModal}
          title={`Transaction Confirmation - PKR ${fare}.0`}
          description={
            <>
              Are you sure you want to proceed with this reservation request?
              <br />
              The amount will be deducted from your wallet.
            </>
          }
          onCancel={handleCancel}
          onConfirm={async () => {
            setOpenModal(false);
            await handleConfirm(false);
          }}
        />
      )}
    </>
  );
}
